<ng-container [formGroup]="formCustomFields">

  <ng-container [ngSwitch]="field.type">
    <ng-container *ngSwitchCase="1">
      <!-- NÚMERO -->
      <div class="form-group row">
        <label for="staticEmail" class="col-sm-5 col-form-label">{{
          (field.alias)?field.alias:field.name }}
          <span class="text-danger" *ngIf="formCustomFields.controls[field.id].errors?.required">&#10033;</span>
        </label>
        <div class="col-sm-6">
          <input type="number" class="form-control" (input)="onChange($event,field)" formControlName="{{ field.id }}"
            [required]="field.required" [readonly]="field.readonly || field.disabled" />
        </div>
        <div class="informacion col-sm-1">
          <i class="fas fa-info-circle" *ngIf="field.hint" [ngbPopover]="field.hint"></i>
        </div>

      </div>
    </ng-container>
    <ng-container *ngSwitchCase="2">
      <!-- TIPO TEXTO -->
      <ng-container
        *ngIf="!field.conditional || formCustomFields?.controls[field.conditional.customfieldid]?.value == field.conditional.customfieldvalue">
        <div class="form-group row">
          <label for="staticEmail" class="col-sm-5 col-form-label">{{
            (field.alias)?field.alias:field.name }}
            <span class="text-danger"
              *ngIf="formCustomFields?.controls[field.id]?.errors?.required || field.required">&#10033;</span>
          </label>
          <div class="col-sm-6">
            <app-customfields-input [type]="'text'" [parentForm]="formCustomFields" [fcName]="field.id"
              (inputChange)="onChange($event,field)" [required]="field.required || null"
              [validationMessage]="field.validationmessage" [pattern]="field.regularexpression || null"
              [maxlength]="fieldMaxLength(field)"
              [format]="field.format || null" [disabled]="field.disabled" [readonly]="isCopyLocked(field)">
            </app-customfields-input>
          </div>
          <div class="informacion col-sm-1">
            <i class="fas fa-info-circle" *ngIf="field.hint" [ngbPopover]="field.hint"></i>
          </div>

        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="3">
      <!-- DATE -->
      <ng-container
        *ngIf="!field.conditional || (field.conditional.hidden !== true ? formCustomFields.controls[field.conditional.customfieldid].value == field.conditional.customfieldvalue : false)">
        <div class="form-group row">
          <label for="staticEmail" class="col-sm-5 col-form-label">{{
            (field.alias)?field.alias:field.name }}
            <span class="text-danger"
              *ngIf="formCustomFields.controls[field.id].errors?.required">&#10033;</span></label>
          <div class="col-sm-6">
            <div *ngIf="(field.name === 'Fecha Plazo' || field.name === 'Fecha firma contrato'); else blockElse"
              class="input-group style-button">
              <input class="form-control " placeholder="dd/mm/yyyy" formControlName="{{ field.id }}" value="valor"
                name="fd" data-cy="date" (dateSelect)="onChange($event,field)" (blur)="onDateBlur($event, field)"
                ngbDatepicker #fd="ngbDatepicker"
                [attr.disabled]="isDisabledDateSla ? '' : null" [ngClass]="{ 'pointer-no-events': isDisabledDateSla }"
                [readonly]="field.readonly" [minDate]="{year: year, month: month, day: day}">
              <div class="input-group-append style-button" [ngClass]="{ 'pointer-no-events': isDisabledDateSla }">
                <button [disabled]="field.readonly" class="btn fas fa-calendar-alt bt" (click)="fd.toggle()" type="button"></button>
              </div>
            </div>
            <ng-template #blockElse>
              <div class="input-group style-button">
                <input class="form-control " placeholder="dd/mm/yyyy" formControlName="{{ field.id }}" value="valor"
                  name="fd" data-cy="date" (dateSelect)="onChange($event,field)" (blur)="onDateBlur($event, field)"
                  ngbDatepicker #fd="ngbDatepicker"
                  [required]="field.required" [readonly]="field.allowedit && edit ? false : field.readonly">
                <div class="input-group-append style-button">
                  <button [disabled]="field.allowedit && edit ? false : field.readonly" class="btn fas fa-calendar-alt bt" (click)="fd.toggle()" type="button"></button>
                </div>
              </div>
            </ng-template>
          </div>
          <div class="informacion col-sm-1">
            <i class="fas fa-info-circle" *ngIf="field.hint" [ngbPopover]="field.hint"></i>
          </div>

        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="4">
      <!-- CHECKBOX -->
      <div class="form-group row">
        <div class="col-sm-5 col-form-label d-flex align-items-center">
          <span>{{(field.alias)?field.alias:field.name }}</span>
          <span class="text-danger ml-1" *ngIf="formCustomFields.controls[field.id].errors?.required || field.required">&#10033;</span>
        </div>
        <div class="col-sm-6 d-flex align-items-center">
          <label class="custom-checkbox-container">
            <input 
              type="checkbox" 
              [id]="'checkbox-' + field.id"
              [formControl]="formCustomFields.controls[field.id]"
              (change)="onCheckboxChangeType4($event, field)"
              [readonly]="field.readonly"
              >
            <span class="custom-checkbox-slider"></span>
            <span class="custom-checkbox-label" *ngIf="field.hint">{{ field.hint }}</span>
          </label>
          <select *ngIf="showCopySourceSelect() && copySourceOptions?.length > 1 && copyIndexFieldId != null && formCustomFields.controls[copyIndexFieldId]"
            class="form-control mt-2"
            data-cy="copy-from-group-source"
            [formControlName]="copyIndexFieldId"
            (change)="onCopySourceIndexChange($event, field)">
            <option *ngFor="let opt of copySourceOptions" [value]="opt.index">{{ opt.label }}</option>
          </select>
        </div>
        <div class="informacion col-sm-1">
          <i class="fas fa-info-circle" *ngIf="field.hint" [ngbPopover]="field.hint"></i>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="5">
      <!-- SELECT SIMPLE -->
      <div class="form-group row">
        <label for="staticEmail" class="col-sm-5 col-form-label">{{(field.alias)?field.alias:field.name }}
          <span class="text-danger" *ngIf="formCustomFields.controls[field.id].errors?.required">&#10033;</span></label>
        <div class="col-sm-6">
          <select class="form-control" formControlName="{{ field.id }}" (change)="onType6Change($event, field)"
            [class.copy-locked]="isCopyLocked(field)"
            [required]="field.required" data-cy="select-simple">
            <ng-container *ngIf="copySourceOptions?.length || copyAllowOther; else staticSimpleOptions">
              <option value="">Seleccionar</option>
              <option *ngFor="let opt of copySourceOptions" [value]="opt.index">{{ opt.label }}</option>
              <option *ngIf="copyAllowOther" [value]="copyOtherValue">{{ copyOtherLabel }}</option>
            </ng-container>
            <ng-template #staticSimpleOptions>
              <option [ngValue]="null" disabled>Seleccionar</option>
              <ng-container *ngFor="let value of field.values">
                <option *ngIf="selectSimpleOptionValue(value)" [value]="selectSimpleOptionValue(value)">
                  {{ selectSimpleOptionLabel(value) }}
                </option>
              </ng-container>
            </ng-template>
          </select>
        </div>
        <div class="informacion col-sm-1">
          <i class="fas fa-info-circle" *ngIf="field.hint" [ngbPopover]="field.hint"></i>
        </div>

      </div>
    </ng-container>

    <ng-container *ngSwitchCase="37">
      <div class="form-group row">
        <label for="staticEmail" class="col-sm-5 col-form-label">{{(field.alias)?field.alias:field.name }}
          <span class="text-danger" *ngIf="formCustomFields.controls[field.id].errors?.required">&#10033;</span></label>
        <div class="col-sm-6">
          <div class="autocomplete-container">
            <input
              type="text"
              class="form-control"
              formControlName="{{ field.id }}"
              [required]="field.required"
              [class.copy-locked]="isCopyLocked(field)"
              [attr.readonly]="isCopyLocked(field) ? '' : null"
              data-cy="autocomplete-simple"
              placeholder="Escriba para buscar..."
              (input)="onAutocompleteInput($event, field)"
              (focus)="showAutocompleteOptions(field)"
              autocomplete="off">

            <!-- Lista de opciones del autocomplete -->
            <div class="autocomplete-options" *ngIf="showOptions && filteredOptions.length > 0">
              <div
                class="autocomplete-option"
                *ngFor="let option of filteredOptions; let i = index"
                [class.selected]="i === selectedOptionIndex"
                (click)="selectOption(option, field)"
                (mouseenter)="selectedOptionIndex = i">
                {{ option }}
              </div>
            </div>
          </div>
        </div>
        <div class="btn-custom col-sm-1" *ngIf="field.action_redirect && field.action_redirect.class && field.action_redirect.url"><i
            [class]="field.action_redirect.class" [ngbTooltip]="field.action_redirect.tooltips" (click)="navigateTo(field.action_redirect.url)"></i>
        </div>
        <div class="informacion col-sm-1" *ngIf="field.hint">
          <i class="fas fa-info-circle"  [ngbPopover]="field.hint"></i>
        </div>

      </div>
    </ng-container>

    <ng-container *ngSwitchCase="6">
      <div class="form-group row">
        <label for="staticEmail" class="col-sm-5 col-form-label">
          {{ (field.alias)?field.alias:field.name }}
          <span class="text-danger" *ngIf="formCustomFields.controls[field.id].errors?.required || field.required">&#10033;
          </span>
        </label>
        <div class="col-sm-6">
          <div class="choice-radios" *ngIf="isRadioChoices(field); else type6Select">
            <label *ngFor="let value of field.values">
              <input type="radio" [value]="value.name"
                formControlName="{{ field.id }}" (change)="onType6Change($event, field)">
              {{ value.name }}
            </label>
          </div>
          <ng-template #type6Select>
          <select class="form-control" formControlName="{{ field.id }}" (change)="onType6Change($event,field)"
            [class.copy-locked]="isCopyLocked(field)"
            [required]="field.required" data-cy="select">
            <option value="">Seleccionar</option>
            <option *ngFor="let value of field.values" [value]="value.name">
              {{ value.name }}
            </option>
          </select>
          </ng-template>
        </div>
        <div class="informacion col-sm-1">
          <i class="fas fa-info-circle" *ngIf="field.hint" [ngbPopover]="field.hint"></i>
        </div>

      </div>
    </ng-container>
    <!-- TEXTAREA WITH DOUBLE SPACE -->
    <ng-container *ngSwitchCase="7">

      <div class="form-group row">
        <label for="staticEmail" class="col-sm-2 col-form-label">{{(field.alias)?field.alias:field.name }}
          <span class="text-danger" *ngIf="formCustomFields.controls[field.id].errors?.required">&#10033;</span></label>
        <div class="col-sm-9">
          <textarea class="form-control" name="" id="" rows="5" (input)="onChange($event,field)"
            formControlName="{{ field.id }}" [required]="field.required" data-cy="textarea">
          </textarea>
        </div>
        <div class="informacion col-sm-1">
          <i class="fas fa-info-circle" *ngIf="field.hint" [ngbPopover]="field.hint"></i>
        </div>

      </div>
    </ng-container>
    <ng-container *ngSwitchCase="8">
      <!-- RUT -->
      <div class="form-group row">
        <label class="col-sm-5 col-form-label">{{ (field.alias)?field.alias:field.name }}
          <span class="text-danger" *ngIf="formCustomFields.controls[field.id].errors?.required || field.required || rucRequiered">&#10033;</span></label>
        <div class="col-sm-6">
          <input class="form-control" [ngClass]="{ 'is-invalid': !formCustomFields.controls[field.id].valid }"
            (input)="formatearRut($event,field)" (keydown)="rutKeyup($event)" formControlName="{{ field.id }}"
            [required]="field.required || rucRequiered" [readonly]="field.readonly || field.disabled" />
          <small class="form-text text-muted danger" *ngIf="formCustomFields.controls[field.id].errors"
            class="invalid-feedback">
            <div class="error-message ">
              {{'Rut Inválido'}}
            </div>
          </small>
        </div>
        <div class="informacion col-sm-1">
          <i class="fas fa-info-circle" *ngIf="field.hint" [ngbPopover]="field.hint"></i>
        </div>

      </div>
    </ng-container>
    <ng-container *ngSwitchCase="9">
      <!-- TEXTAREA -->
      <div class="form-group row">
        <label for="staticEmail" class="col-sm-5 col-form-label">{{(field.alias)?field.alias:field.name }}
          <span class="text-danger" *ngIf="formCustomFields.controls[field.id].errors?.required">&#10033;</span></label>
        <div class="col-sm-6">
          <textarea class="form-control" name="" id="" rows="3" (input)="onChange($event,field)"
            formControlName="{{ field.id }}" [required]="field.required" data-cy="textarea">
                        </textarea>
        </div>
        <div class="informacion col-sm-1">
          <i class="fas fa-info-circle" *ngIf="field.hint" [ngbPopover]="field.hint"></i>
        </div>

      </div>
    </ng-container>

    <!-- type 10 checkboxes collection -->
    <ng-container *ngSwitchCase="10">
      <div class="parent-c">
        <label for="groupCkeck" class="">{{ (field.alias)?field.alias:field.name }}
          <span class="text-danger" *ngIf="field.required">&#10033;</span>
        </label>
        <ng-container *ngIf="(edit || flagActionLog) && field.value!='' && field.value!=null; else blockElse">
          <form [formGroup]="searchForm">
            <input type="text" class="form-control" (input)="onValueChangeSearch($event.target.value,field)"
              formControlName="search" placeholder="Buscar Materia" />
          </form>
          <div class="cuadrar">
            <div formArrayName="{{field.id}}" *ngFor="let item of field.value; let i = index">
              <div class="form-check">
                <div>
                  <label class="form-check-label" for="{{ item.name }}">
                    <input class="form-check-input" type="checkbox" id="{{ item.name }}" [value]="item.name"
                      [checked]="item.value" (change)="onCheckboxChange($event,field.id)" />
                    {{ item.name }}

                  </label>
                </div>
              </div>
              <br />
            </div>
          </div>
        </ng-container>
        <ng-template #blockElse>
          <form [formGroup]="searchForm">
            <input type="text" class="form-control" (input)="onValueChangeSearch($event.target.value,field)"
              formControlName="search" placeholder="Buscar Materia" />
          </form>
          <div class="cuadrar">
            <div formArrayName="{{field.id}}" *ngFor="let item of field.values; let i = index">
              <div>
                <div class="form-check">
                  <label class="form-check-label" for="{{ item.name }}">
                    <input class="form-check-input" type="checkbox" id="{{ item.name }}" [value]="item.name"
                      [checked]="item.value" (change)="onCheckboxChange($event,field.id)" />
                    {{ item.name }}
                  </label>
                </div>
              </div>
              <br />
            </div>
          </div>
        </ng-template>
      </div>
    </ng-container>
    <!-- type 12  multifields to text(12) -->
    <ng-container *ngSwitchCase="12" formArrayName="{{ field['id'] }}">
      <ng-container *ngFor="let control of formCustomFields['controls'][field['id']]['controls']; let i=index">
        <div [formGroupName]="i" class="form-group row">
          <label class="col-sm-5 col-form-label">{{ (field.alias)?field.alias:field.name }}
            <span class="text-danger" *ngIf="formCustomFields.controls[field.id].errors?.required">&#10033;</span>
          </label>
          <div class="col-sm-5 pr-0">
            <input class="form-control" [ngClass]="{ 'is-invalid': !formCustomFields.controls[field.id].valid }"
              formControlName="values" (input)="onChange($event,field)" [required]="field.required"
              [placeholder]="(field.alias)?field.alias:field.name+' #'+(i+1)" [readonly]="field.readonly" />
            <small class="form-text text-muted danger"
              *ngIf="formCustomFields.controls[field.id].errors || !formCustomFields.controls[field.id].valid"
              class="invalid-feedback">
              <div class="error-message ">
                {{(field.alias)?field.alias:field.name +' #'+(i+1)+' Inválido'}}
              </div>
            </small>
          </div>
          <div class="col-sm-2 pr-0">
            <button *ngIf="formCustomFields.controls[field.id].value.length >= 1 && i != 0" type="button"
              class="btn btn-outline-danger mr-1" (click)="removeInput(i, field.id)">
              <i class="far fa-trash-alt"></i>
            </button>
            <button *ngIf="formCustomFields['controls'][field['id']]['value'].length >= 1 && i === 0" type="button"
              class="btn btn-outline-primary mr-1" (click)="addInput(field['id'], field['type'])">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <!-- type 13  multifields to Rut(13) -->
    <ng-container *ngSwitchCase="13" formArrayName="{{ field['id'] }}">
      <ng-container *ngFor="let control of formCustomFields['controls'][field['id']]['controls']; let i=index">
        <div [formGroupName]="i" class="form-group row">
          <label class="col-sm-5 col-form-label">{{ (field.alias)?field.alias:field.name }}
            <span class="text-danger" *ngIf="formCustomFields.controls[field.id].errors?.required">&#10033;</span>
          </label>
          <div class="col-sm-5 pr-0">
            <input class="form-control" [ngClass]="{ 'is-invalid': !formCustomFields.controls[field.id].valid }"
              (input)="formatearRut($event,field,i)" (keydown)="rutKeyup($event)" formControlName="values"
              [required]="field.required" [placeholder]="(field.alias)?field.alias:field.name+' #'+(i+1)"
              [readonly]="field.readonly" />
            <small class="form-text text-muted danger"
              *ngIf="formCustomFields.controls[field.id].errors || !formCustomFields.controls[field.id].valid"
              class="invalid-feedback">
              <div class="error-message ">
                {{'Rut '+'#'+(i+1)+' Inválido'}}
              </div>
            </small>
          </div>
          <div class="col-sm-2 pr-0">
            <button *ngIf="formCustomFields.controls[field.id].value.length >= 1 && i != 0" type="button"
              class="btn btn-outline-danger mr-1" (click)="removeInput(i, field.id)">
              <i class="far fa-trash-alt"></i>
            </button>
            <button *ngIf="formCustomFields['controls'][field['id']]['value'].length >= 1 && i === 0" type="button"
              class="btn btn-outline-primary mr-1" (click)="addInput(field['id'], field['type'])">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="14">
      <!-- SELECT 14 -->

      <div [formArrayName]="'' + field.id" [class.copy-locked]="isCopyLocked(field)">
        <div class="form-group row" formGroupName="0">
          <label for="dinamicSelect" class="col-sm-5 col-form-label">{{ (field.alias)?field.alias:field.name }}
            <span class="text-danger" *ngIf="field.required">&#10033;</span></label>
          <div class="col-sm-6">
            <select class="form-control" formControlName="seleccion"
              [class.copy-locked]="isCopyLocked(field)"
              (change)="onChange($event,field); setItemSelected($event.target.value)" [required]="field.required">
              <option value="">Seleccionar</option>
              <option *ngFor="let value of field.values" [value]="'' + value.id">
                {{ value.name }}
              </option>
            </select>
          </div>
          <div class="informacion col-sm-1">
            <i class="fas fa-info-circle" *ngIf="field.hint" [ngbPopover]="field.hint"></i>
          </div>

        </div>
      </div>

      <div [class.copy-locked]="isCopyLocked(field)" *ngIf="!hideContractSubtypeUi()">
        <div class="">
          <div></div>
          <app-tree-select [nestedValues]="nestedValues" [itemSelected]="type14DepartamentoId || setSelectValue" [counterTree]="counterTree"
            [parentForm]="formCustomFields" [controlId]="field.id" [required]="field.required" [controlLevel]=1
            [labeltext]="nextName" [fieldSelected]="fieldSelected"
            [searchable]="type14NestedSearchable(field)" (selectChange)="onChange($event,field)">
          </app-tree-select>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="15">
      <!-- TIPO EMAIL -->
      <div class="form-group row">
        <label for="staticEmail" class="col-sm-5 col-form-label">{{ (field.alias)?field.alias:field.name }}
          <span class="text-danger" *ngIf="formCustomFields.controls[field.id].errors?.required">&#10033;</span></label>
        <div class="col-sm-6">
          <app-customfields-input [type]="'email'" [parentForm]="formCustomFields" [fcName]="field.id"
            [required]="field.required || null" (inputChange)="onChange($event,field)"
            [validationMessage]="field.validationmessage">
          </app-customfields-input>
        </div>
        <div class="informacion col-sm-1">
          <i class="fas fa-info-circle" *ngIf="field.hint" [ngbPopover]="field.hint"></i>
        </div>

      </div>
    </ng-container>
    <ng-container *ngSwitchCase="18">
      <!-- SELECT QUE MUESTRA LA DATA EN OTROS GRUPOS -->
      <ng-container formArrayName="{{ field.id }}">
        <ng-container *ngFor="let data of formCustomFields?.controls[field.id]?.controls || []; let i = index"
          [formGroupName]="i">
          <div class="form-group row">
            <div class="col-sm-5">
              <label for="staticEmail" class="col-form-label">{{ field.name }} {{ i + 1 }}
                <span class="text-danger fw-bold fs-1"
                  *ngIf="field.required && !fieldIsNotEmpty[field.name + i]">&#10033;</span></label>
              <a *ngIf="i < 1 ? true : false" type="button" class="pl-2" (click)="addData(field,'')">
                <i class="fas fa-plus"></i>
              </a>
            </div>
            <div class="col-sm-6 select2-style">
              <ng-select [items]="field.values.values"  formControlName="value"
                (change)="onValueChange($event, field.name, i)" [required]="field.required">
              </ng-select>
              <a type="button" *ngIf="i < 1 ? false : true" (click)="removeData(i, field.id)">Remover</a>
            </div>
            <div class="informacion col-sm-1">
              <i class="fas fa-info-circle" *ngIf="field.hint" [ngbPopover]="field.hint"></i>
            </div>

          </div>
          <ng-container *ngIf="context === 'edition'">
            <div class="col-sm-6">
              <div class="form-group row">
                <div class="col-sm-5">
                  <label for="staticEmail" class="col-form-label">{{data.value.data.adittional_fields[1].field_name }}
                    {{ i
                    + 1 }}
                    <span class="text-danger"
                      *ngIf="!fieldIsNotEmpty[data.value.data.adittional_fields[1].field_name + i]">&#10033;</span></label>
                </div>
                <div class="col-sm-7">
                  <select class="form-control" formControlName="{{ data.value.data.adittional_fields[1].field }}"
                    (change)="onValueChange($event.target.value,data.value.data.adittional_fields[1].field_name,i)
                                        " [required]="field.required">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let value of data.value.data.adittional_fields[1].items" [value]="value">
                      {{ value }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group row">
                <div class="col-sm-5">
                  <label for="staticEmail" class="col-form-label">{{
                    data.value.data.adittional_fields[2].field_name }} {{ i + 1 }}
                    <span class="text-danger"
                      *ngIf="!fieldIsNotEmpty[data.value.data.adittional_fields[2].field_name + i]">&#10033;</span></label>
                </div>
                <div class="col-sm-7">
                  <input type="number" class="form-control" (input)="onValueChange($event.target.value,data.value.data.adittional_fields[2].field_name,i)
                                    " formControlName="{{ data.value.data.adittional_fields[2].field }}"
                    [required]="field.required" [readonly]="field.readonly" />
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="19">
      <ng-container formArrayName="{{ field.id }}">
        <!-- Fields Second Step{{ field | json}}  -->
        <ng-container *ngFor="let data of formCustomFields.controls[field.id]['controls'];let i = index">
          <ng-container *ngFor="let adField of field.data.adittional_fields">
            <ng-container [ngSwitch]="adField.type">
              <ng-container *ngSwitchCase="2">
                <div class="col-sm-6" [formGroupName]="i">
                  <div class="form-group row">
                    <div class="col-sm-5">
                      <label for="staticEmail" class="col-form-label">{{ adField.field_name }} {{
                        i + 1 }}</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control" formControlName="{{ adField.field }}" readonly />
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="5">
                <div class="col-sm-6" [formGroupName]="i">
                  <div class="form-group row">
                    <div class="col-sm-5">
                      <label for="staticEmail" class="col-form-label">{{ adField.field_name }} {{
                        i + 1 }}
                        <span class="text-danger"
                          *ngIf="!fieldIsNotEmpty[adField.field_name + i]">&#10033;</span></label>
                    </div>
                    <div class="col-sm-7">
                      <select class="form-control" formControlName="{{ adField.field }}"
                        (change)="onValueChange($event.target.value,adField.field_name,i)" [required]="field.required">
                        <option value="">Seleccionar</option>
                        <option *ngFor="let value of adField.items" [value]="value">
                          {{ value }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="1">
                <div class="col-sm-6" [formGroupName]="i">
                  <div class="form-group row">
                    <div class="col-sm-5">
                      <label for="staticEmail" class="col-form-label">{{adField.field_name }} {{ i
                        + 1 }}
                        <span class="text-danger"
                          *ngIf="!fieldIsNotEmpty[adField.field_name + i]">&#10033;</span></label>
                    </div>
                    <div class="col-sm-7">
                      <input type="number" class="form-control"
                        (input)="onValueChange($event.target.value,adField.field_name,i)"
                        formControlName="{{ adField.field }}" [required]="field.required" [readonly]="field.readonly" />
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="20">
      <ng-container formGroupName="{{ field.id }}">
        <ng-container *ngIf="hideContractSubtypeUi(); else type20WithSubtype">
          <div class="form-group row">
            <label for="staticEmail" class="col-sm-5 col-form-label">{{ field.name }}
              <span class="text-danger"
                *ngIf="formCustomFields.controls[field.id]?.get('type')?.errors?.required || field.required">&#10033;</span>
            </label>
            <div class="col-sm-6">
              <select class="form-control" formControlName="type" (change)="onChange($event, field)"
                [required]="field.required">
                <option value="" disabled>Seleccionar</option>
                <option *ngFor="let value of field.values.type" [value]="value.id">
                  {{ value.name }}
                </option>
              </select>
            </div>
            <div class="informacion col-sm-1">
              <i class="fas fa-info-circle" *ngIf="field.hint" [ngbPopover]="field.hint"></i>
            </div>
          </div>
        </ng-container>
        <ng-template #type20WithSubtype>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group row">
                <label for="staticEmail" class="col-sm-5 col-form-label">{{ field.name }}
                  <span class="text-danger"
                    *ngIf="formCustomFields.controls[field.id]?.get('type')?.errors?.required || field.required">&#10033;</span>
                </label>
                <div class="col-sm-7">
                  <select class="form-control" formControlName="type" (change)="onChange($event, field)"
                    [required]="field.required">
                    <option value="" disabled>Seleccionar</option>
                    <option *ngFor="let value of field.values.type" [value]="value.id">
                      {{ value.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group row">
                <label for="staticEmail" class="col-sm-5 col-form-label">{{ field.values?.subtype.name }}
                  <span class="text-danger"
                    *ngIf="formCustomFields.controls[field.id]?.get('subtype')?.errors?.required || field.required">&#10033;</span>
                </label>
                <div class="col-sm-7">
                  <select class="form-control" formControlName="subtype" (change)="parseSubType($event, field)"
                    [required]="field.required">
                    <option value="" disabled>Seleccionar</option>
                    <option *ngFor="let type of subtype" [value]="type">
                      {{ type }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="22">
      <!-- TIP PLAZO -->
      <div class="row">
        <ng-container formGroupName="{{ field.id }}">
          <div class="col-md-6">
            <div class="form-group row">
              <label for="staticEmail" class="col-sm-5 col-form-label">{{ field.name }}
                <span class="text-danger"
                  *ngIf="formCustomFields.controls[field.id].errors?.required">&#10033;</span></label>
              <div class="col-sm-7">
                <select class="form-control" formControlName="type" (change)="onChange($event,field)"
                  [required]="field.required">
                  <option value="" disabled>-- {{ field.name }} --</option>
                  <option *ngFor="let value of field.values.types" [value]="value.id">
                    {{ value.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <!-- Fecha Revisión -->
            <div class="form-group row" *ngIf="typePlazo === 1">
              <label for="staticEmail" class="col-sm-5 col-form-label">Fecha Revisión</label>
              <div class="col-sm-7">
                <div class="input-group style-button">
                  <input class="form-control " placeholder="dd/mm/yyyy" formControlName="fecharevision"
                    [value]="formCustomFields.controls[field.id]['controls']['fecharevision'].value" name="fd1"
                    data-cy="date" (dateSelect)="getItem22Values($event, 'fecharevision')" ngbDatepicker
                    #fd1="ngbDatepicker">
                  <div class="input-group-append style-button">
                    <button class="btn fas fa-calendar-alt bt" (click)="fd1.toggle()" type="button"></button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fecha Vencimiento -->
            <div class="form-group row" *ngIf="typePlazo === 2">
              <label for="staticEmail" class="col-sm-5 col-form-label">Fecha Vencimiento </label>
              <div class="col-sm-7">
                <div class="input-group style-button">
                  <input class="form-control " placeholder="dd/mm/yyyy" formControlName="fechavencimiento"
                    [value]="formCustomFields.controls[field.id]['controls']['fechavencimiento'].value" name="fd"
                    data-cy="date" (dateSelect)="getItem22Values($event, 'fechavencimiento')" ngbDatepicker
                    #fd="ngbDatepicker">
                  <div class="input-group-append style-button">
                    <button class="btn fas fa-calendar-alt bt" (click)="fd.toggle()" type="button"></button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Condición -->
            <div class="form-group row" *ngIf="typePlazo === 3">
              <label for="staticEmail" class="col-sm-5 col-form-label">Condición</label>
              <div class="col-sm-7">
                <input type="text" class="form-control" (input)="getItem22Values($event.target.value, 'condicion')"
                  formControlName="condicion"
                  [value]="formCustomFields.controls[field.id]['controls']['condicion'].value"
                  placeholder="Condición" />
              </div>
            </div>
          </div>
          <div class="col-md-6" *ngIf="typePlazo === 1 || typePlazo === 2">
            <!-- Aviso término días -->
            <div class="form-group row">
              <label for="staticEmail" class="col-sm-5 col-form-label">Aviso término días</label>
              <div class="col-sm-7">
                <input type="number" class="form-control"
                  (input)="getItem22Values($event.target.value, 'avisoterminodias')" formControlName="avisoterminodias"
                  [value]="formCustomFields.controls[field.id]['controls']['avisoterminodias'].value"
                  placeholder="Días" />
              </div>
            </div>
          </div>
          <div class="col-md-6" *ngIf="typePlazo === 2">
            <!-- Periodicidad de Renovación (meses) -->
            <div class="form-group row">
              <label for="staticEmail" class="col-sm-5 col-form-label">Periodicidad de Renovación
                (meses)</label>
              <div class="col-sm-7">
                <input type="number" class="form-control" (input)="getItem22Values($event.target.value, 'periodicidad')"
                  formControlName="periodicidad"
                  [value]="formCustomFields.controls[field.id]['controls']['periodicidad'].value"
                  placeholder="1-12 Meses" />
              </div>
            </div>
          </div>
          <div class="col-md-6" *ngIf="typePlazo === 2">
            <!-- Renovación Automática  -->
            <div class="form-group row">
              <label for="staticEmail" class="col-sm-5 col-form-label">Renovación Automática</label>
              <div class="col-md-7 d-flex align-items-center">
                <div class="form-check form-check-inline"
                  *ngFor="let item of field.values?.renovacionautomatica; let i = index">
                  <input class="form-check-input" type="radio" id="field_renovacionautomatica_{{ i }}"
                    (change)="onCheckRadioChange(item.name,field,'renovacionautomatica')"
                    formControlName="renovacionautomatica" [value]="item.name">
                  <label class="form-check-label" for="field_renovacionautomatica_{{ i }}">{{
                    item.name }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <!-- Carta aviso término enviada por término de contrato -->
            <div class="form-group row" *ngIf="edit">
              <label for="staticEmail" class="col-sm-5 col-form-label">Carta aviso término enviada por
                término de contrato</label>
              <div class="col-md-7 d-flex align-items-center">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" id="field_carta_aviso_0"
                    (change)="onCheckRadioChange('si',field,'carta_aviso')" formControlName="carta_aviso"
                    [value]="'si'">
                  <label class="form-check-label" for="field_carta_aviso_0">si</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" id="field_carta_aviso_1"
                    (change)="onCheckRadioChange('no',field,'carta_aviso')" formControlName="carta_aviso"
                    [value]="'no'">
                  <label class="form-check-label" for="field_carta_aviso_1">no</label>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="21">
      <!-- RADIO BUTTON -->
      <div class="form-group row">
        <label for="staticEmail" class="col-sm-5 col-form-label">{{ field.name }}
          <span class="text-danger"
            *ngIf="formCustomFields.controls[field.id].errors?.required || field.required">&#10033;</span>
        </label>
        <div class="col-md-7 d-flex align-items-center">
          <div class="form-check form-check-inline" *ngFor="let item of field.values; let i = index">
            <input class="form-check-input" type="radio" id="field_{{ field.id }}_{{ i }}"
              (change)="onCheckRadioChange(item.name,field,'default')" formControlName="{{ field.id }}"
              [value]="item.name">
            <label class="form-check-label" for="field_{{ field.id }}_{{ i }}">{{ item.name}}</label>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="23">
      <!-- SELECT SIMPLE WITH INPUT TEXT -->
      <div class="form-group row">
        <label class="col-sm-5 col-form-label">{{ (field.alias)?field.alias:field.name }}
          <span class="text-danger" *ngIf="formCustomFields.controls[field.id].errors?.required">&#10033;</span></label>
        <div class="col-sm-7">
          <select class="form-control" formControlName="{{ field.id }}" (change)="onChange($event,field)"
            [required]="field.required">
            <option value="" disabled>Seleccionar Moneda</option>
            <option *ngFor="let value of field.values; let i = index" [value]="value.id">
              {{ value.name +' ('+value.symbol+')' }}
            </option>
          </select>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="24">
      <!-- Terminado-->
      <ng-container formGroupName="{{ field.id }}">
        <!-- {{ field | json }} -->
        <div class="col-md-6">
          <div class="form-group row">
            <label for="staticEmail" class="col-sm-5 col-form-label">
              Cuantia $
              <span class="text-danger" *ngIf="!fieldIsNotEmpty['cuantia']">&#10033;</span>
            </label>
            <div class="col-sm-7">
              <input type="number" class="form-control" (input)="getItem24Values($event.target.value, 'cuantia')"
                formControlName="cuantia_$" [value]="formCustomFields.controls[field.id]['controls']['cuantia_$'].value"
                [required]="true" [readonly]="field.readonly" />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group row">
            <label for="staticEmail" class="col-sm-5 col-form-label"> Monto Pagado $
              <span class="text-danger" *ngIf="!fieldIsNotEmpty['monto_pago']">&#10033;</span>
            </label>
            <div class="col-sm-7">
              <input type="number" class="form-control" (input)="getItem24Values($event.target.value, 'monto_pago')"
                formControlName="monto_pagado_$" [required]="true" [readonly]="field.readonly" />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group row">
            <label for="staticEmail" class="col-sm-5 col-form-label">Monto Ahorrado $</label>
            <div class="col-sm-7">
              <input type="number" class="form-control" (input)="getItem24Values($event.target.value, 'monto_ahorrado')"
                formControlName="monto_ahorrado_$"
                [value]="formCustomFields.controls[field.id]['controls']['monto_ahorrado_$'].value" [required]="false"
                readonly />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group row">
            <label for="staticEmail" class="col-sm-5 col-form-label">% Ahorrado</label>
            <div class="col-sm-7">
              <input type="number" class="form-control"
                (input)="getItem24Values($event.target.value, 'porcentaje_ahorrado')"
                formControlName="porcentaje_ahorrado"
                value="{{formCustomFields.controls[field.id]['controls']['porcentaje_ahorrado'].value}}"
                [required]="false" readonly />
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="25">
      <ng-container formArrayName="{{ field.id }}">
        <ng-container *ngFor="let data of formCustomFields.controls[field.id]['controls']; let i = index">
          <div class="form-group row">
            <div class="col-sm-5">
              <label for="staticEmail" class="col-form-label">{{ field.name }} {{ i + 1 }}
                <span class="text-danger fw-bold fs-1"
                  *ngIf=" field.required && !fieldIsNotEmpty[field.name + i]">&#10033;</span></label>
              <a *ngIf="i < 1 ? true : false" type="button" class="pl-2" (click)="addInputToArray(field.id)">
                <i class="fas fa-plus"></i>
              </a>
            </div>
            <div class="col-sm-7 select2-style">
              <input type="text" class="form-control" [formControlName]="i"
                (input)="onValueChange($event, field.name, i)" [required]="field.required || null" />
              <a type="button" *ngIf="i < 1 ? false : true" (click)="removeData(i, field.id)">Remover</a>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="26">
      <ng-container formArrayName="{{ field.id }}">
        <ng-container *ngFor="let data of formCustomFields.controls[field.id]['controls']; let i = index">
          <div class="col-sm-6" [formGroupName]="i">
            <div class="form-group row">
              <div class="col-sm-5">
                <label for="staticEmail" class="col-form-label">{{ field.values.parent_name}} {{i + 1}}
                  <span class="text-danger"
                    *ngIf="!fieldIsNotEmpty[field.values.parent_name + i] && field.required">&#10033;</span></label>
                <i *ngIf="formCustomFields.controls[field.id]['controls'].length > 1" class="btn fas fa-times ml-2 px-0"
                  (click)="deleteItem(field.id, i); field.values.child_items.splice(i, 1)"></i>
                <i *ngIf="i == 0" class="btn fas fa-plus ml-2 px-0" (click)="addItem(field.id)"></i>
              </div>
              <div class="col-sm-7">
                <select class="form-control" formControlName="parent"
                  (change)="onValueChange26($event.target.value,field.values,i) " [required]="field.required">
                  <option value="">Seleccionar</option>
                  <option *ngFor="let value of field.values.items" [value]="value.value">
                    {{ value.value }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-sm-6" [formGroupName]="i">
            <div class="form-group row">
              <div class="col-sm-5">
                <label for="staticEmail" class="col-form-label">{{ field.values.child_name}} {{i + 1}}
                  <span class="text-danger"
                    *ngIf="!fieldIsNotEmpty[field.values.child_name + i] && field.required">&#10033;</span></label>
              </div>
              <div class="col-sm-7">
                <select class="form-control" formControlName="child"
                  (change)="onValueChange($event.target.value,field.values.child_name,i)" [required]="field.required">
                  <option value="">Seleccionar</option>
                  <option *ngFor="let value of field.values.child_items[i]" [value]="value">
                    {{ value }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="27">
      <!-- REPETIDOR -->
      <ng-container [formArrayName]="field.id"
        *ngFor="let item of formCustomFields.controls[field.id]['controls']; let i = index">
        <ng-container [formGroupName]="i">
          <ng-container *ngFor="let f of field.values; let c = index">
            <div class="form-group row">
              <label for="" class="col-sm-5 col-form-label"> {{ f.name }} {{ i + 1 }}
                <button type="button" class="btn btn-sm btn-link text-dark shadow-none" *ngIf="i > 0 && c == 0"
                  (click)="removeItemRepeater(field, i)"><i class="fas fa-times"></i></button>
                <button type="button" class="btn btn-sm btn-link text-dark shadow-none" *ngIf="i == 0 && c == 0"
                  (click)="addItemRepeater(field)"><i class="fas fa-plus"></i></button>
              </label>
              <div class="col-sm-7">
                <ng-container [ngSwitch]="f.type">
                  <ng-container *ngSwitchCase="2">
                    <input type="text" class="form-control" [formControlName]="f.field_name">
                  </ng-container>
                  <ng-container *ngSwitchCase="5">
                    <select class="form-control" [formControlName]="f.field_name">
                      <option value="">Seleccionar</option>
                      <option *ngFor="let it of f.items" [value]="it">{{ it }}
                      </option>
                    </select>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="28">
      <ng-container [formGroupName]="field.id">
        <div class="col-sm-6">
          <div class="form-group row">
            <label class="col-sm-5">{{ field.values.parent_name }}</label>
            <div class="col-sm-7">
              <select class="form-control" formControlName="select" (change)="findItemSelect(field)">
                <option value="">Seleccionar</option>
                <option *ngFor="let it of field.values.items" [value]="it.value">{{ it.value }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group row">
            <label class="col-sm-5">{{ field.values.child_name }}</label>
            <div class="col-sm-7">
              <input type="text" class="form-control"
                [value]="formCustomFields.controls[field.id]['controls'].itemName.value" disabled
                [readonly]="field.readonly">
            </div>
          </div>
        </div>
      </ng-container>

    </ng-container>
    <ng-container *ngSwitchCase="29">
      <ng-container formArrayName="{{ field.id }}">
        <ng-container *ngFor="let data of formCustomFields.controls[field.id]['controls'];let i = index">
          <ng-container *ngFor="let adField of field.values.fields">
            <ng-container [ngSwitch]="adField.type">
              <ng-container *ngSwitchCase="1">
                <div class="col-sm-6" [formGroupName]="i">
                  <div class="form-group row">
                    <div class="col-sm-5">
                      <label for="staticEmail" class="col-form-label">{{ adField.field_name }}
                        <span class="text-danger"
                          *ngIf="!fieldIsNotEmpty[adField.field_name + i]">&#10033;</span></label>
                    </div>
                    <div class="col-sm-7">
                      <input type="number" class="form-control"
                        (input)="onValueChange($event.target.value,adField.field_name,i)"
                        formControlName="{{ adField.field }}" [required]="'adField.required'"
                        [readonly]="field.readonly" />
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="3">
                <div class="col-sm-6" [formGroupName]="i">
                  <div class="form-group row">
                    <div class="col-sm-5">
                      <label for="staticEmail" class="col-form-label">{{ adField.field_name }}
                        <span class="text-danger"
                          *ngIf="!fieldIsNotEmpty[adField.field_name + i]">&#10033;</span></label>
                    </div>
                    <div class="col-sm-7">
                      <input type="date" class="form-control"
                        (input)="onValueChange($event.target.value,adField.field_name,i)"
                        formControlName="{{ adField.field }}" [required]="'adField.required'"
                        [readonly]="field.readonly" />
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="2">
                <div class="col-sm-6" [formGroupName]="i">
                  <div class="form-group row">
                    <div class="col-sm-5">
                      <label for="staticEmail" class="col-form-label">{{adField.field_name}} asd
                        <span class="text-danger" *ngIf="!fieldIsNotEmpty[adField.field_name + i]">&#10033;</span>
                      </label>
                    </div>
                    <div class="col-sm-7">
                      <input type="text" class="form-control"
                        (input)="onValueChange($event.target.value,adField.field_name,i)"
                        formControlName="{{ adField.field }}" [required]="'adField.required'"
                        [readonly]="field.readonly" />
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="50">
      <!-- SELECT SIMPLE -->
      <div class="form-group row">
        <label for="staticEmail" class="col-sm-5 col-form-label">{{ field.name }}
          <span class="text-danger" *ngIf="field.required">&#10033;</span></label>
        <div class="col-sm-6">
          <select class="form-control" formControlName="{{ field.id }}" (change)="onValueChange50($event.target.value)"
            [required]="field.required">
            <option value="" disabled>Seleccionar</option>
            <option *ngFor="let value of field.values" [value]="value.id">
              {{ value.text }}
            </option>
          </select>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="51">
      <!-- SELECT SIMPLE -->
      <div class="form-group row">
        <label for="staticEmail" class="col-sm-5 col-form-label">{{ field.name }}
          <span class="text-danger" *ngIf="field.required">&#10033;</span></label>
        <div class="col-sm-6">
          <select class="form-control" formControlName="{{ field.id }}" (change)="onChange($event,field)"
            [required]="field.required">
            <option value="" disabled>Seleccionar</option>
            <option *ngFor="let value of field.values" [value]="value">
              {{ value }}
            </option>
          </select>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="52">
      <!-- SELECT id/name (tipo 52); hijo con dependsOn puede usar action_redirect → /admin/client -->
      <ng-container *ngIf="fieldVisible(field)">
        <div class="form-group row">
          <label for="staticEmail" class="col-sm-5 col-form-label">{{ (field.alias) ? field.alias : field.name }}
            <span class="text-danger" *ngIf="field.required">&#10033;</span></label>
          <div class="col-sm-6">
            <select class="form-control" formControlName="{{ field.id }}" (change)="onChange($event,field)"
              [required]="field.required">
              <option value="" disabled>Seleccionar</option>
              <option *ngFor="let value of field.values" [value]="value.id">
                {{ value.name }}
              </option>
            </select>
          </div>
          <div class="btn-custom col-sm-1" *ngIf="field.action_redirect?.class && field.action_redirect?.url">
            <i [class]="field.action_redirect.class" [ngbTooltip]="field.action_redirect.tooltips"
              (click)="navigateTo(field.action_redirect.url)"></i>
          </div>
          <div class="informacion col-sm-1" *ngIf="field.hint">
            <i class="fas fa-info-circle" [ngbPopover]="field.hint"></i>
          </div>
        </div>
      </ng-container>
    </ng-container>


    <!-- CAMPO COMPLETADOS -->
    <ng-container *ngSwitchCase="45">
      <div class="form-group row">
        <label class="col-sm-5 col-form-label">{{(field.alias)?field.alias:field.name}}
          <span class="text-danger" *ngIf="formCustomFields.controls[field.id].errors?.required">&#10033;</span>
        </label>
        <div class="col-sm-7">
          <input class="form-control alert" type="text"
            [ngClass]="{ 'is-invalid': formCustomFields.controls[field.id].errors?.forbiddenName }"
            [ngStyle]="{ 'margin-bottom': formCustomFields.controls[field.id].errors?.forbiddenName ? 0 : '1rem' }"
            formControlName="{{ field.id }}" [required]="field.required" readonly />
          <small class="form-text text-muted danger" *ngIf="formCustomFields.controls[field.id].errors?.forbiddenName"
            class="invalid-feedback">
            <div class="error-message ">
              {{'Indeterminado'}}
            </div>
          </small>
        </div>
      </div>
    </ng-container>

    <!-- CAMPO HORA (input nativo; evita spinner ngb-timepicker) -->
    <ng-container *ngSwitchCase="16">
      <div class="form-group row">
        <label class="col-sm-5 col-form-label">{{(field.alias)?field.alias:field.name}}
          <span class="text-danger" *ngIf="field.required">&#10033;</span>
        </label>
        <div class="col-sm-7">
          <div class="input-group">
            <input
              type="time"
              class="form-control"
              [formControlName]="field.id"
              (change)="onType16TimeChange(field, $event)"
              [required]="type16InputRequiredForView()" />
            <div class="input-group-append">
              <span class="input-group-text"><i class="fas fa-clock"></i></span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- TIPO 55: SELECT ANIDADO CON DOBLE SUB (CECO + RESPONSABLE) -->
    <ng-container *ngSwitchCase="55">
      <ng-container [formArrayName]="field.id">
        <ng-container formGroupName="0">
          <!-- Select principal: Tienda -->
          <div class="form-group row">
            <label class="col-sm-5 col-form-label">{{ field.name }}
              <span class="text-danger" *ngIf="field.required">&#10033;</span></label>
            <div class="col-sm-6">
              <select class="form-control" formControlName="seleccion"
                (change)="onChangeType55($event.target.value, field)" [required]="field.required">
                <option value="">Seleccionar</option>
                <option *ngFor="let value of field.values" [value]="value.id">
                  {{ value.name }}
                </option>
              </select>
            </div>
            <div class="informacion col-sm-1">
              <i class="fas fa-info-circle" *ngIf="field.hint" [ngbPopover]="field.hint"></i>
            </div>
          </div>

          <!-- Sub1: CECO -->
          <ng-container *ngIf="type55Sub1Items.length > 0" formArrayName="sub">
            <div class="form-group row" formGroupName="0">
              <label class="col-sm-5 col-form-label">{{ type55Sub1Label }}</label>
              <div class="col-sm-6">
                <select class="form-control" formControlName="seleccion1"
                  (change)="onChange($event, field)" [required]="field.required">
                  <option value="">Seleccionar</option>
                  <option *ngFor="let item of type55Sub1Items" [value]="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
          </ng-container>

          <!-- Sub2: Responsable Tienda -->
          <ng-container *ngIf="type55Sub2Items.length > 0" formArrayName="sub2">
            <div class="form-group row" formGroupName="0">
              <label class="col-sm-5 col-form-label">{{ type55Sub2Label }}</label>
              <div class="col-sm-6">
                <select class="form-control" formControlName="seleccion2_1"
                  (change)="onChange($event, field)" [required]="field.required">
                  <option value="">Seleccionar</option>
                  <option *ngFor="let item of type55Sub2Items" [value]="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- TIPO 54: TOGGLE SWITCH -->
    <ng-container *ngSwitchCase="54">
      <div class="form-group row">
        <div class="col-sm-12 d-flex align-items-center justify-content-center">
          <div class="toggle-switch-container">
            <label class="toggle-label-left" [class.active]="!formCustomFields.controls[field.id].value">
              {{ field.values?.leftLabel || 'Opción 1' }}
            </label>
            <label class="toggle-switch">
              <input 
                type="checkbox" 
                [formControl]="formCustomFields.controls[field.id]"
                (change)="onToggleSwitchChange($event, field)"
                [readonly]="field.readonly">
              <span class="toggle-slider"></span>
            </label>
            <label class="toggle-label-right" [class.active]="formCustomFields.controls[field.id].value">
              {{ field.values?.rightLabel || 'Opción 2' }}
            </label>
          </div>
          <span class="text-danger ml-2" *ngIf="formCustomFields.controls[field.id].errors?.required || field.required">&#10033;</span>
          <i class="fas fa-info-circle ml-2" *ngIf="field.hint" [ngbPopover]="field.hint"></i>
        </div>
      </div>
    </ng-container>

    <!-- TIPO 53: SELECT TIPO EMPRESA CON DOCUMENTOS Y ARCHIVOS -->
    <ng-container *ngSwitchCase="53">
      <div [formGroup]="formCustomFields">
        <ng-container [formGroupName]="field.id">
          <!-- Select de Tipo de Empresa -->
          <div class="form-group row">
            <label for="tipoEmpresa" class="col-sm-5 col-form-label">
              {{ (field.alias)?field.alias:field.name }}
              <span class="text-danger" *ngIf="field.required">&#10033;</span>
            </label>
            <div class="col-sm-6">
              <select
                class="form-control"
                formControlName="tipoEmpresa"
                (change)="onTipoEmpresaChange($event, field); onChange($event, field)"
                [required]="field.required">
                <option value="">Seleccionar</option>
                <option *ngFor="let empresa of getTipoEmpresaOptions(field)" [value]="empresa.id">
                  {{ empresa.name }}
                </option>
              </select>
            </div>
            <div class="informacion col-sm-1">
              <i class="fas fa-info-circle" *ngIf="field.hint" [ngbPopover]="field.hint"></i>
            </div>
          </div>

          <!-- Lista según la opción elegida. checklist = prototipo (Obligatorio / Opcional). -->
          <ng-container *ngIf="isDocChecklist(field) && getTipoEmpresaSeleccionado(field)">
            <div class="tipo53-checklist">
              <div class="tipo53-checklist__head">Documentos requeridos</div>
              <div formArrayName="documentos">
                <label
                  class="tipo53-checklist__row"
                  *ngFor="let documento of getDocumentosArray(field).controls; let i = index"
                  [formGroupName]="i"
                  [attr.for]="'file-' + field.id + '-' + i">
                  <span class="tipo53-checklist__name">
                    <i class="far fa-file-alt"></i>
                    <span>
                      {{ getDocumentoName(field, documento.get('fileId')?.value) || ('Documento ' + (i + 1)) }}
                      <small *ngIf="archivoElegido(documento)">{{ archivoElegido(documento) }}</small>
                      <small class="tipo53-checklist__missing" *ngIf="documento.get('file')?.errors?.required">Adjunta este documento</small>
                    </span>
                  </span>
                  <span class="tipo53-checklist__state">{{ documentoObligatorio(field, documento) ? 'Obligatorio' : 'Opcional' }}</span>
                  <input
                    type="file"
                    class="d-none"
                    [id]="'file-' + field.id + '-' + i"
                    (change)="onFileChange($event, field, i)">
                </label>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!isDocChecklist(field) && getTipoEmpresaSeleccionado(field)">
            <ng-container formArrayName="documentos">
              <div
                *ngFor="let documento of getDocumentosArray(field).controls; let i = index"
                [formGroupName]="i"
                class="form-group row">
                <label class="col-sm-5 col-form-label">
                  {{ getDocumentoName(field, documento.get('fileId')?.value) || ('Documento ' + (i + 1)) }}
                </label>
                <div class="col-sm-7">
                  <div class="d-flex align-items-center">
                    <input
                      type="file"
                      class="d-none"
                      #fileInput
                      [id]="'file-' + field.id + '-' + i"
                      (change)="onFileChange($event, field, i)"
                      [required]="field.required">
                    <button
                      type="button"
                      class="btn btn-outline-primary d-flex align-items-center justify-content-center"
                      style="min-width: 120px; height: 38px;"
                      (click)="fileInput.click()">
                      <i class="fas fa-cloud-upload-alt mr-2"></i>
                      <span>Subir</span>
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
